import { useAuth } from "../../hooks/useAuth";

export default function Header() {
  const { user } = useAuth();

  return (
    <header className="flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6">
      <div className="flex items-center gap-4 lg:hidden">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-simsy-600">
            <span className="text-sm font-bold text-white">S</span>
          </div>
          <span className="text-lg font-semibold text-gray-900">SIMSY</span>
        </div>
      </div>

      <div className="hidden lg:block">
        <h1 className="text-sm font-medium text-gray-500">Customer Portal</h1>
      </div>

      <div className="flex items-center gap-4">
        {user?.email && (
          <div className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-simsy-100 text-simsy-700">
              <span className="text-xs font-medium">
                {user.email.charAt(0).toUpperCase()}
              </span>
            </div>
            <span className="hidden text-sm text-gray-700 sm:block">
              {user.email}
            </span>
          </div>
        )}
      </div>
    </header>
  );
}
